<template>
  <div>
    <button @click="setCookie">set</button>
    <button @click="getCookie">get</button>
  <el-card style="marginBottom: 15px">
    <el-steps align-center>
      <el-step :status="inMonths(val)" v-for="val in vals" :title="val" :key="val"></el-step>
    </el-steps>
  </el-card>
  <el-card v-loading="loading" class="page" key="hello">
    <ReportTable :tableData="tableData"/>
  </el-card>
  </div>
</template>

<script>
// import moment from 'moment'
import Cookies from 'js-cookie'
import ReportTable from './ReportTable.vue'
import {auth} from '../main'
import {getReportsMixin} from './getReportsMixin'
import 'element-ui/lib/theme-chalk/index.css';

export default {
  components: {
    ReportTable
  },
  mixins: [getReportsMixin],
  name: 'dashboard',
  data () {
    return {
      loading: false,
      months: [],
      vals: ['Jan 18', 'Feb 18', 'Mar 18', 'Apr 18', 'May 18', 'Jun 18'],
      userId: auth.currentUser.uid
    };
  },
  created () {
    this.fetchData()
  },
  computed: {
    getMonths () {
      return this.tableData.map(row => row.month.format('MMM YY'))
    }
  },
  methods: {
    setCookie () {
      Cookies.set('token', 'vhgfjdkhgjdhgkjdfhgjhfdkgjgdfjkghkdjfhgkj', {expires: 7, domain: 'p3i-inc.com'});
    },
    getCookie () {
      console.log(Cookies.get())
    },
    logout: function () {
      auth.signOut()
        .then(() => {
          this.$router.replace('login');
      });
    },
    inMonths (month) {
      return this.getMonths.includes(month) ? 'success' : 'wait'
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .page {
    position: absolute;
    overflow: scroll;
    height: calc(100vh - 200px);
    width: calc(100vw - 240px)
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue